import {DateTime} from 'luxon';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {PurchaseButton} from '../../../../../libs/shared/ui/src/components/buttons/purchaseButton';
import {useLinkNavigation} from '../../../../../libs/shared/ui/src/components/navigation/useLinkNavigation';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {createSelector} from '../../../../../srcCommon/helpers/reselectHelpers';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {SettingsBillingPagesEnum} from '../../../../models/url/models/billingUrlModel';
import {SettingsRootPagesEnum} from '../../../../models/url/models/types';
import {buildSettingsPath} from '../../../../models/url/settingsUrlHelpers';
import {getCompanyCreatedAt, getDaysLeftInTrial} from '../../../../store/data/company/companySelectors';

/*
 * Props.
 */

interface BottomBarPurchaseButtonProps {}

/*
 * Selectors.
 */

const getDaysSinceCreation = createSelector([getCompanyCreatedAt], (createdAt) => {
  const now = DateTime.now();
  const creationDate = DateTime.fromMillis(createdAt);
  return now.diff(creationDate, 'days').days;
});

/*
 * Component.
 */

export const BottomBarPurchaseButton: FC<BottomBarPurchaseButtonProps> = (props) => {
  const daysSinceCreation = useAppSelector(getDaysSinceCreation);
  const daysLeftInTrial = useAppSelector(getDaysLeftInTrial);

  const {navigateToLink} = useLinkNavigation();
  const {trackDataEvent} = useDataEventTracking();

  const onClick = () => {
    navigateToLink(
      buildSettingsPath({
        rootPage: SettingsRootPagesEnum.BILLING,
        resourcePage: SettingsBillingPagesEnum.NEW,
      }),
    );
    trackDataEvent(DataEventActionsEnum.CLICK, OnboardingDataEventObject.PURCHASE);
  };

  return (
    <PurchaseButton size={VisualSizesEnum.SMALL} onClick={onClick}>
      {daysSinceCreation <= 3 && daysLeftInTrial > 3 ? (
        <Trans id="bottom-bar-purchase-button-early">Compare plans</Trans>
      ) : (
        <Trans id="bottom-bar-purchase-button-late">Buy now</Trans>
      )}
    </PurchaseButton>
  );
};
